import React, { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import SplitNumber from "../../../components/SplitNumber";
import { isMobile } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import AddToBasketRoundedButton from "../../../components/addToBasketRoundedButton";
import { IconErrorCircle, IconTooman } from "../../../../assets/icons";
function CardItem({
  imageUrl,
  amusementName,
  price,
  amusementUrl,
  originalPrice,
  hasReserveDetail_V2,
}) {
  const [loaded, setLoaded] = useState(false);
  return isMobile ? (
    <Col xs="6" sm="4" md="3" className="mt-2">
      <Link to={amusementUrl}>
        <Card className="bg-white shadow-sm rounded-3 p-1 h-100">
          <Card.Body className="p-0 text-center">
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "auto",
              }}
            >
              {!loaded && (
                <Skeleton height="90px" width="100%" className="rounded-3" />
              )}
              <img
                src={imageUrl + "?width=200"}
                alt={amusementName}
                className="rounded-3 mb-1"
                style={{
                  display: loaded ? "block" : "none",
                  width: "100%",
                }}
                onLoad={() => setLoaded(true)}
              />
            </div>
            <div className=" mt-3 ">
              <h6 className="text-black fw-bold fs-normal mb-2 border-bottom pb-2">
                {amusementName}
              </h6>
              {hasReserveDetail_V2 ? (
                originalPrice > price ? (
                  <div>
                    <span className="text-black-06 fs-075 text-decoration-line-throught-rotate border-secondary">
                      <SplitNumber number={originalPrice} />
                    </span>
                    <span className="medium-svg">
                      <IconTooman
                        fillColor="#444"
                        style={{ marginTop: "-7px" }}
                      />
                    </span>
                  </div>
                ) : (
                  ""
                )
              ) : (
                <div className="fs-075 text-black-06">عدم امکان رزرو</div>
              )}
            </div>
          </Card.Body>
          <Card.Footer className="bg-white border-top-0 pt-0 px-2 text-center rounded-3">
            {hasReserveDetail_V2 ? (
              <>
                <div className=" fw-bold fs-085 pb-1 pt-1">
                  <SplitNumber number={price} />
                  <span className="medium-svg ">
                    <IconTooman style={{ marginTop: "-7px" }} />
                  </span>
                </div>
                <Button
                  variant="outline-success"
                  className="fs-075 mt-1 rounded-2 w-100"
                  style={{ background: "rgb(233 251 245)" }}
                >
                  مشاهده و رزرو
                </Button>
              </>
            ) : (
              <div className=" fs-07">
                <IconErrorCircle fillColor="#444" />
                در حال حاضر رزرو غیرفعال است
              </div>
            )}
          </Card.Footer>
        </Card>
      </Link>
    </Col>
  ) : (
    <div className="my-1 col-custom">
      <Link to={amusementUrl}>
        <Card className="p-2 rounded-3 shadow-sm border text-center h-100">
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "auto",
            }}
          >
            {!loaded && (
              <Skeleton height="90px" width="100%" className="rounded-3" />
            )}
            <img
              src={imageUrl + "?width=200"}
              alt={amusementName}
              className="rounded-3 mb-1"
              style={{
                display: loaded ? "block" : "none",
                width: "100%",
              }}
              onLoad={() => setLoaded(true)}
            />
          </div>
          <Card.Body className="px-0 pb-0">
            <h6 className="text-black fw-bold fs-normal pb-3 border-bottom">
              {amusementName}
            </h6>

            {hasReserveDetail_V2 ? (
              ""
            ) : (
              <div className="text-secondary">عدم امکان رزرو</div>
            )}
          </Card.Body>
          {hasReserveDetail_V2 ? (
            <Card.Footer className="bg-white border-0 ">
              <Row className="gx-0">
                <Col
                  xs="12"
                  className="my-auto d-flex align-items-center justify-content-between"
                >
                  {originalPrice > price && (
                    <div>
                      <span className="text-black-06 fs-08 text-decoration-line-throught-rotate border-secondary">
                        <SplitNumber number={originalPrice} />
                      </span>
                    </div>
                  )}
                  <div className="fw-bold text-black medium-svg">
                    <span className=" text-dark">
                      <SplitNumber number={price} />
                    </span>
                    <IconTooman style={{ marginTop: "-7px" }} />
                  </div>
                </Col>
                <Col xs="12" className="mt-2">
                  <AddToBasketRoundedButton
                  // onClick={handleClick}
                  />
                </Col>
              </Row>
            </Card.Footer>
          ) : (
            <Card.Footer className="bg-white border-0 fs-07">
              <IconErrorCircle fillColor="#444" />
              در حال حاضر رزرو غیرفعال است
            </Card.Footer>
          )}
        </Card>
      </Link>
    </div>
  );
}

export default CardItem;
